import Vue from 'vue';
const CodeMirror = require('codemirror/lib/codemirror.js');
require('codemirror/lib/codemirror.css');

export default Vue.component('codemirror', {
  template: require('./template.html'),
  data() {
    return {
      skipNextChangeEvent: false,
    };
  },
  name: 'codemirror',
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          mode: 'text/javascript',
          lineNumbers: true,
          lineWrapping: true,
        };
      },
    },
  },
  ready() {
    const _this = this;
    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
    this.editor.setValue(this.value);
    this.editor.on('change', (cm) => {
      if (_this.skipNextChangeEvent) {
        _this.skipNextChangeEvent = false;
        return;
      }
      _this.value = cm.getValue();
      if (!!_this.$emit) {
        _this.$emit('change', cm.getValue());
      }
    });
  },
  mounted() {
    var _this = this;
    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
    this.editor.setValue(this.value);
    this.editor.on('change', (cm) => {
      if (_this.skipNextChangeEvent) {
        _this.skipNextChangeEvent = false;
        return;
      }
      if (!!_this.$emit) {
        _this.$emit('change', cm.getValue());
        _this.$emit('input', cm.getValue());
      }
    });
  },
  watch: {
    value(newVal, oldVal) {
      var editorValue = this.editor.getValue();
      if (newVal !== editorValue) {
        this.skipNextChangeEvent = true;
        var scrollInfo = this.editor.getScrollInfo();
        this.editor.setValue(newVal);
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
      }
    },
    options(newOptions, oldVal) {
      if (typeof newOptions === 'object') {
        for (var optionName in newOptions) {
          if (newOptions.hasOwnProperty(optionName)) {
            this.editor.setOption(optionName, newOptions[optionName]);
          }
        }
      }
    },
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.toTextArea();
    }
  },
});



// WEBPACK FOOTER //
// ./src/modules/codemirror/index.js